import TooltipModule from './tooltip.module'

export default TooltipModule
